import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';
import RichTextInput from 'assets/components/inputs/richTextInput/RichTextInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import CheckWrapper from 'assets/components/inputs/wrappers/CheckWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import Modal from 'assets/components/page/templates/Modal';
import ThemeModalDefault from 'assets/components/page/templates/themes/Theme.Modal.Default';
import { getLocales } from 'assets/locales/Locale';
import ClaimJobEmailTemplateTags from 'module/management/components/claimJobEmailTemplate/ClaimJobEmailTemplateTags';
import { useClaimJobEdit } from './ClaimEdit.Job.Hooks';

export default function ClaimEditJobEmailTemplate() {
  const { lang } = getLocales();
  const { changeJobStatusForm, setEmailAction } = useClaimJobEdit();

  function updateEmailTemplate(updatedEmailTemplate: Partial<Model.IClaimJobEmailTemplate>) {
    changeJobStatusForm.merge({ claimJobEmailTemplate: updatedEmailTemplate });
  }
  function handleChangeStatus({ claimJobEmailTemplate }: { claimJobEmailTemplate: Model.IClaimJobEmailTemplate }) {
    changeJobStatusForm.update({ claimJobEmailTemplate });
    setEmailAction(null);
    changeJobStatusForm.submit();
  }

  return !changeJobStatusForm.data?.claimJobEmailTemplate ? null : (
    <>
      <Modal
        subcomponents={ThemeModalDefault}
        header={lang.emailTemplate}
        onClose={() => changeJobStatusForm.update({ claimJobEmailTemplate: null })}
        render={
          <FormWrapper>
            <TextInput
              name="name"
              label={lang.name}
              value={changeJobStatusForm.data.claimJobEmailTemplate.name}
              error={changeJobStatusForm.errors.claimJobEmailTemplate?.name}
              onChange={updateEmailTemplate}
              icon={<Icon class="if-quill-pen" />}
            />
            <InputWrapper>
              <TextInput
                name="senderName"
                label={lang.senderName}
                value={changeJobStatusForm.data.claimJobEmailTemplate.senderName}
                error={changeJobStatusForm.errors.claimJobEmailTemplate?.senderName}
                onChange={updateEmailTemplate}
                icon={<Icon class="if-quill-pen" />}
              />
              <TextInput
                name="senderEmail"
                label={lang.senderEmail}
                value={changeJobStatusForm.data.claimJobEmailTemplate.senderEmail}
                error={changeJobStatusForm.errors.claimJobEmailTemplate?.senderEmail}
                onChange={updateEmailTemplate}
                icon={<Icon class="if-quill-pen" />}
              />
            </InputWrapper>
            <h2>{lang.sendTo}</h2>
            <CheckWrapper>
              <CheckInput
                name="sendToClient"
                label={lang.client}
                class={inputStyles.check.switch}
                value={changeJobStatusForm.data.claimJobEmailTemplate?.sendToClient}
                onChange={updateEmailTemplate}
                htmlElementProps={{
                  title: changeJobStatusForm.data.claimJobEmailTemplate?.sendToClient ? lang.disable : lang.enable,
                }}
              />
              <CheckInput
                name="sendToContactEmail"
                label={lang.contact}
                class={inputStyles.check.switch}
                value={changeJobStatusForm.data.claimJobEmailTemplate?.sendToContactEmail}
                onChange={updateEmailTemplate}
                htmlElementProps={{
                  title: changeJobStatusForm.data.claimJobEmailTemplate?.sendToContactEmail
                    ? lang.disable
                    : lang.enable,
                }}
              />
              <CheckInput
                name="sendToClaimOwner"
                label={lang.claimOwner}
                class={inputStyles.check.switch}
                value={changeJobStatusForm.data.claimJobEmailTemplate?.sendToClaimOwner}
                onChange={updateEmailTemplate}
                htmlElementProps={{
                  title: changeJobStatusForm.data.claimJobEmailTemplate?.sendToClaimOwner ? lang.disable : lang.enable,
                }}
              />
            </CheckWrapper>
            <h2>{lang.additionalRecipientEmails}</h2>
            <DataMap
              data={[...(changeJobStatusForm.data.claimJobEmailTemplate?.additionalRecipientEmails || []), '']}
              render={({ data: email, index }) => (
                <TextInput
                  key={index}
                  name="email"
                  label={lang.email}
                  value={email}
                  error={changeJobStatusForm.errors.claimJobEmailTemplate?.additionalRecipientEmails}
                  onChange={({ email }) => {
                    let additionalRecipientEmails =
                      changeJobStatusForm.data.claimJobEmailTemplate?.additionalRecipientEmails || [];
                    additionalRecipientEmails.splice(index, 1, email);
                    additionalRecipientEmails = additionalRecipientEmails.filter((it) => it);
                    changeJobStatusForm.update({
                      claimJobEmailTemplate: {
                        ...changeJobStatusForm.data.claimJobEmailTemplate,
                        additionalRecipientEmails,
                      },
                    });
                  }}
                  icon={<Icon class="if-quill-pen" />}
                />
              )}
            />
            <h2>{lang.email}</h2>
            <TextInput
              name="subject"
              label={lang.subject}
              value={changeJobStatusForm.data.claimJobEmailTemplate.subject}
              error={changeJobStatusForm.errors.claimJobEmailTemplate?.subject}
              onChange={updateEmailTemplate}
              icon={<Icon class="if-quill-pen" />}
            />
            <RichTextInput
              name="htmlBody"
              label={lang.htmlBody}
              value={changeJobStatusForm.data.claimJobEmailTemplate.htmlBody}
              error={changeJobStatusForm.errors.claimJobEmailTemplate?.htmlBody}
              onChange={updateEmailTemplate}
              icon={<Icon class="if-quill-pen" />}
              customActions={<ClaimJobEmailTemplateTags />}
            />
          </FormWrapper>
        }
        footer={
          <>
            <Button
              onClick={handleChangeStatus}
              data={{ claimJobEmailTemplate: null }}
              media="fas-ban"
              render={lang.changeStatusAndDontSendEmail}
              class={ThemeButtonCircle}
              disabled={changeJobStatusForm.isSubmitted || changeJobStatusForm.hasErrors}
            />
            <Button
              onClick={handleChangeStatus}
              data={{ claimJobEmailTemplate: changeJobStatusForm.data?.claimJobEmailTemplate }}
              media="fas-save"
              disabled={changeJobStatusForm.isSubmitted || changeJobStatusForm.hasErrors}
              render={lang.changeStatusAndSendEmail}
              class={ThemeButtonCircle}
              active
            />
          </>
        }
      />
    </>
  );
}
